/* src/app/ai-sourcing/jd-description/jd-description.component.scss */
.ats-upload-btn {
  width: 100px !important;
  height: 10px !important;
  border: none !important;
  color: #2e93a1;
  display: flex;
  box-sizing: border-box;
  position: relative;
  background-color: none !important;
  border-radius: 5px;
}
.btn-trms-medium.bg-gray {
  background-color: #969696 !important;
  color: #fff !important;
  border: 0px !important;
}
.holding {
  background-image: url("./media/jobfilterbg-P5CSB5CK.png");
  background-size: cover;
  background-position: center;
  color: #ffffff;
  padding: 15px;
}
.holding .webbtree-ai {
  font-size: 18px;
  font-weight: 600;
  background:
    linear-gradient(
      90deg,
      #57E7FB 0%,
      #ED1EAF 30%);
  color: transparent;
  background-clip: text;
}
.confirm-banner {
  font-size: 12px;
  font-weight: 400;
  margin: 0;
  line-height: 1.5;
  margin-bottom: 3px;
}
.landing {
  color: transparent;
  background-clip: text;
  top: -5px !important;
  background:
    linear-gradient(
      90deg,
      #ED1EAF 0%,
      #ED1EAF 100%);
  background-clip: text;
}
/*# sourceMappingURL=jd-description.component-KHQUFCSF.css.map */
